import { Link } from 'react-router-dom';
import { BookOpen, ChevronRight, Clock, Sparkles } from './Icons';
import { type Attempt } from '@mastery/api-client-web';
import { labels, date, Empty } from '../lib/shared';

export function AttemptList({ rows, loading = false }: { rows: Attempt[]; loading?: boolean }) {
  if (loading)
    return (
      <div className="panel loading-inline" role="status">
        正在读取学习记录…
      </div>
    );
  return (
    <div className="panel list">
      {rows.length ? (
        rows.map((a) => {
          const Icon = a.mode === 'mock' ? Clock : a.mode === 'adaptive' ? Sparkles : BookOpen;
          const pending = !!a.result?.pending;
          return (
            <Link key={a.id} className="attempt-row" to={'/attempts/' + a.id}>
              <span className="square-icon">
                <Icon size={20} />
              </span>
              <div className="grow">
                <strong>{a.title}</strong>
                <small>
                  {labels[a.mode]} · {date(a.started_at)}
                </small>
              </div>
              <div className="attempt-outcome">
                <span className={'pill ' + (pending || a.status === 'in_progress' ? 'amber' : '')}>
                  {pending ? '待教师批改' : labels[a.status]}
                </span>
                {a.result && !pending && (
                  <strong>
                    {a.result.score}
                    <small> / {a.result.max_score} 分</small>
                  </strong>
                )}
              </div>
              <ChevronRight size={18} />
            </Link>
          );
        })
      ) : (
        <Empty>还没有学习记录，完成第一组练习后会出现在这里。</Empty>
      )}
    </div>
  );
}
